"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decrypt = decrypt;
exports.encrypt = encrypt;
var _jsencrypt = _interopRequireDefault(require("jsencrypt/bin/jsencrypt"));
// 密钥对生成 http://web.chacuo.net/netrsakeypair

var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5EQOJw0ZevD7s8zhaOw3\n' + 'x8Whp5y1eOE0bILH93ezR2/Qtn2jv7C5Eug1yr9BqIYiLgKkZ+P4XXFeejWLCdgU\n' + '0QYsE7cvbNvwqZJhx53GlFG2lKLrFbv2nrrdjAKqEWphByK8rcz6swPyOK9b7mwA\n' + 'oQcDrUmbksqlFIffSJ9/BMZDeQqghKtT0a9r8L79GUm6+0VX9UZ/BkV64bhG5QAa\n' + '3o3lfAMmIKsqU1qAL481ZjEIEAcihXsspN5Jtg/WYtbP0h5IQw4lGtGHbqxgbdps\n' + '8whGZnfzI6RQN3eH5EbzYiJKbh36WkgLRgBiEuAcaMC4LtDqzbEi8xun3+eONXeu\n' + 'iwIDAQAB';
var privateKey = 'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' + 'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' + 'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' + '/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' + 'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' + 'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' + '4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' + 'tTbklZkD2A==';

// 加密
function encrypt(txt) {
  var encryptor = new _jsencrypt.default();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对需要加密的数据进行加密
}

// 解密
function decrypt(txt) {
  var encryptor = new _jsencrypt.default();
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(txt);
}